import { TextField, type SxProps, type Theme } from '@mui/material'
import type React from 'react'

interface SurveyTextFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  rows?: number
  height?: string | number
  dataTestId?: string
  sx?: SxProps<Theme>
}

const defaultSx: SxProps<Theme> = {
  width: '750px',
  display: 'flex',
  '& .MuiFilledInput-root': {
    backgroundColor: 'var(--grey-100)',
    '&:hover': {
      backgroundColor: 'var(--grey-100)'
    },
    '&.Mui-focused': {
      backgroundColor: 'var(--grey-100)'
    }
  }
}

export const SurveyTextField: React.FC<SurveyTextFieldProps> = ({
  value,
  onChange,
  placeholder,
  dataTestId,
  height,
  sx
}) => {
  return (
    <TextField
      multiline
      variant="filled"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={3}
      data-testid={dataTestId}
      sx={{
        ...defaultSx,
        height,
        ...sx
      }}
    />
  )
}
